import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Link,
  Typography
} from '@mui/material';
import LegalDocumentModal from '../../Legal/LegalDocumentModal';

const INTEGRATION_COPY = {
  google: {
    title: 'Connect Gmail',
    continueLabel: 'Continue to Google',
    body:
      'Connect your Gmail so you can sync couple emails and send replies from Idotoo. We will access mailbox content and send mail only to power this feature. You can disconnect any time.'
  },
  microsoft: {
    title: 'Connect Microsoft 365 / Outlook',
    continueLabel: 'Continue to Microsoft',
    body:
      'Connect Outlook / Microsoft 365 to sync and reply to couple emails in Idotoo. We will access your mailbox only for this feature. You can disconnect any time.'
  },
  mailchimp: {
    title: 'Connect Mailchimp',
    continueLabel: 'Continue to Mailchimp',
    body:
      'Connect Mailchimp to sync consented enquiry contacts into your audience. We will access your Mailchimp account and selected audience only for this sync. You can disconnect any time.'
  }
};

/**
 * Pre-OAuth privacy disclosure shown before connecting third-party integrations.
 */
function IntegrationPrivacyConsentDialog({
  open,
  integration,
  onClose,
  onConfirm,
  confirming = false
}) {
  const [privacyModalOpen, setPrivacyModalOpen] = useState(false);
  const copy = INTEGRATION_COPY[integration] || null;

  const handleClose = () => {
    if (confirming) return;
    setPrivacyModalOpen(false);
    onClose();
  };

  return (
    <>
      <Dialog
        open={open && Boolean(copy)}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        aria-labelledby="integration-privacy-consent-title"
      >
        <DialogTitle id="integration-privacy-consent-title">
          {copy?.title || 'Connect integration'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div" sx={{ mb: 1.5 }}>
            {copy?.body}
          </DialogContentText>
          <Typography variant="body2" color="text.secondary">
            For full details on data access, use, retention, and your rights, see our{' '}
            <Link
              component="button"
              type="button"
              variant="body2"
              onClick={() => setPrivacyModalOpen(true)}
              sx={{ verticalAlign: 'baseline' }}
            >
              Privacy Policy
            </Link>
            .
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleClose} disabled={confirming}>
            Cancel
          </Button>
          <Button variant="contained" onClick={onConfirm} disabled={confirming || !copy}>
            {confirming ? 'Redirecting…' : copy?.continueLabel || 'Continue'}
          </Button>
        </DialogActions>
      </Dialog>

      <LegalDocumentModal
        open={privacyModalOpen}
        onClose={() => setPrivacyModalOpen(false)}
        fileName="privacy-policy"
        title="Privacy Policy"
      />
    </>
  );
}

export default IntegrationPrivacyConsentDialog;
export { INTEGRATION_COPY };
